const LOCAL_STORAGE_TEMPLATE_SET_SELECTION = 'aryaTemplateSetSelection'

export default {
  inject: [
    '$utils'
  ],
  methods: {
    /**
     * Save template set selection into local storage
     * @param {Array} selection
     */
    setTemplateSetSelectionToLocalStorage (selection) {
      if (this.getTemplateSetSelectionFromLocalStorage !== null) {
        this.removeTemplateSetSelectionFromLocalStorage()
      }

      localStorage.setItem(LOCAL_STORAGE_TEMPLATE_SET_SELECTION, JSON.stringify(selection))
    },
    getTemplateSetSelectionFromLocalStorage () {
      const templateSetSelection = localStorage.getItem(LOCAL_STORAGE_TEMPLATE_SET_SELECTION)

      if (templateSetSelection !== null) {
        return JSON.parse(templateSetSelection)
      }

      return null
    },
    removeTemplateSetSelectionFromLocalStorage () {
      if (this.getTemplateSetSelectionFromLocalStorage !== null) {
        localStorage.removeItem(LOCAL_STORAGE_TEMPLATE_SET_SELECTION)
      }
    },
    convertProjectDataItemValue (dataItemsObj, converstionType) {
      const isObjectType = (val) => { return typeof (val) === 'object' }
      const isBackgroundColorItem = (val) => { return val === 'backgroundColor' }
      const backgroundColorConversion = (colorVal) => {
        let backgroundColor = colorVal
        const exemptValues = ['backgroundColor', 'foregroundColor', 'logoColor', 'textColor', 'subtextColor']

        if (backgroundColor && exemptValues.indexOf(backgroundColor) < 0) {
          if (converstionType === 'backendToUI') {
            backgroundColor = this.$utils.hexToRgb(backgroundColor, true)
          } else if (converstionType === 'UIToBackend') {
            backgroundColor = this.$utils.rgbToHex(backgroundColor, true)
          }
        }

        return backgroundColor
      }

      // Find background color and update value
      const newDataItemsObj = dataItemsObj
      for (const indx in newDataItemsObj) {
        const objProperty = newDataItemsObj[indx]

        if (isObjectType(objProperty)) {
          for (const dataItemKey in objProperty) {
            const dataItem = objProperty[dataItemKey]

            if (isObjectType(dataItem)) {
              for (const itemDetailsKey in dataItem) {
                const itemDetails = dataItem[itemDetailsKey]

                // If background color item
                if (isBackgroundColorItem(itemDetailsKey)) {
                  dataItem[itemDetailsKey] = backgroundColorConversion(itemDetails)
                }
              }
            }
          }
        } else {
          // If background color item
          if (isBackgroundColorItem(objProperty)) {
            newDataItemsObj[indx][objProperty] = backgroundColorConversion(objProperty)
          }
        }
      }

      return newDataItemsObj
    }
  }
}
